import classNames from 'classnames'
import { HTMLAttributes } from 'react'

export const Hotspot = ({
  className,
  ...props
}: HTMLAttributes<HTMLButtonElement>) => (
  <button className={classNames('hotspot', className)} {...props} />
)
